import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {BsModalRef} from 'ngx-bootstrap/modal';
import {AssetsService} from '@webu/data';
import {Router} from '@angular/router';
import {AppState, selectActiveVehicle, TrackingService} from '@ox/data';
import {Store} from '@ngrx/store';
import {AutoDestroy, replaceVariable} from '@ox/utils';
import {Subject, takeUntil} from 'rxjs';

@Component({
  selector: 'webu-service-modal',
  templateUrl: './service-modal.html'
})
export class ServiceModalComponent implements OnInit {
  @AutoDestroy destroy$: Subject<void> = new Subject<void>();
  showCategory = true;
  showsubCategory = true;
  subcategoryclosebtn = false;
  mainmodalcontent = true;
  secondmodalcontent = false;
  previousbtn = false;
  showIndicator = true;

  index: number;
  headingValue: string;
  descriptionValue: string;
  assets: object = {};
  product: any;
  value: string[];
  route: string;
  oldIndex: any;

  activeSlideIndex: number;
  featureCopyList: any;
  storedImageValue: any[];
  newStorageArray: any[];
  imagedisplay: any;
  isPlanModify: boolean;
  activeSlide: number;

  @Output() selectedProductChange: EventEmitter<any> = new EventEmitter();
  @Input() public theme: any;
  @Input() feature: any[];
  @Input() featureValue: any[];
  @Input() activeProduct: any;
  @Input() features: any;

  @Input() displayPlanName: any;
  @Input() displayImage: any;
  @Input() displayPlanNameBilling: any;
  @Input() displayImageBilling: any;
  @Input() featureByo: string[];

  public featurePopupResponse: any;

  constructor(
    public bsModalRef: BsModalRef,
    public assetsService: AssetsService,
    private router: Router,
    private store: Store<AppState>,
    public trackingService: TrackingService
  ) {}
  activeVehicle$ = this.store.select(selectActiveVehicle);

  ngOnInit(): void {
    this.isPlanModify = this.router.url.includes('/myplans/yearly-billing');
    this.displayPlanName = this.isPlanModify ? this.displayPlanNameBilling : this.displayPlanName;
    this.displayImage = this.isPlanModify ? this.displayImageBilling : this.displayImage;
    this.setPlanImage();
    this.setDisplayName();
    this.setServiceModal();

    this.storedImageValue = [];
    this.featureCopyList = this.feature || [];

    const featureListValueItemByo = this.featureByo?.forEach((item: any) => {
      this.featureCopyList = item;
    });
  }

  //direct service modal componenet
  setServiceModal() {
    this.subcategoryclosebtn = true;
    //calling images from assests.json
    this.assetsService?.getAssets().pipe(
      takeUntil(this.destroy$))
      .subscribe({
      next: (asset) => {
        if (asset) {
          this.featurePopupResponse = asset;
          this.features = asset.features;

          this.filterAndSetIndex();
        }
      },
      error: (error) => {
        console.error('Error fetching assets', error);
      }
    });
  }

  filterAndSetIndex() {
    const assetsMap = new Map(this.features.map((asset: any) => 
      [this.replaceBrand(asset.name).toLowerCase(), asset])
    );
    const arrayValue: Array<any> = [];
  
    this.featureCopyList?.forEach((feature: any) => {
      const featureName = this.replaceBrand(feature.name);
      const asset: any = assetsMap.get(featureName.toLowerCase());
      if (asset) {
        const obj = {
          name: asset.name,
          description: feature.description,
          image: asset.featureAssets[0].brands[0].assets[0].urlPath
        };
        arrayValue.push(obj);
      }
    });
  
    this.newStorageArray = arrayValue;
    this.setActiveSlide();
  }

  setActiveSlide() {
    this.activeSlide = this.newStorageArray.findIndex(
      (feature) => feature.name.toLowerCase() === this.featureValue[0].name.toLowerCase()
    );
  }

  // function for plan image from assest json API for Modal
  setPlanImage() {
    if (this.displayImage) {
      this.displayImage?.forEach((img: any) => {
        this.imagedisplay = img;
      });
    }
  }

  setDisplayName() {
    this.product = this.displayPlanName;
  }

  // inner click function for service modal
  goToService(value?: any, name?: any, index?: any) {
    this.secondmodalcontent = true;
    this.mainmodalcontent = false;
    this.showCategory = false;
    this.showsubCategory = true;
    this.subcategoryclosebtn = true;

    this.featureCopyList = this.displayPlanName[0].features;
    this.featureValue = [this.displayPlanName[0].features[index]];
    this.previousbtn = true;
    this.filterAndSetIndex();
  }

  resetView() {
    this.showsubCategory = false;
    this.showCategory = true;
  }

  toTitleCase(value: string) {
    return value.replace(/\w\S*/g, function (text: string) {
      return (
        text.charAt(0).toUpperCase() + text.substring(1)?.toLowerCase() ?? ''
      );
    });
  }

  replaceBrand(text: string, brand?: string) {
    if (brand && brand !== 'GMC') {
      brand = this.toTitleCase(brand);
    }
    return replaceVariable(text, {
      Brand: brand || ''
    });
  }

  change(index: number) {
    if (index < 0 || index === this.oldIndex) {
      return;
    }
  
    const productCode = this.product && this.product.length > 0 ? this.product[0].code : '';
    const featureName = this.newStorageArray[index].name;
    const productOrCode = (this.activeProduct || productCode)?.code;
  
    const trackingString = `shop:update plan:${featureName}:features carousel:${productOrCode}:scroller:click`;
  
    this.trackingService.fireProp10Tracking(trackingString, '', '', 'scroller', '', true);
    this.oldIndex = index;
  }
}